export default class BackInStockPopup {
  constructor(component) {
    this.dom = {
      $component: component,
      $closePopUp: document.querySelectorAll('.js-bisPopUpClose'),
      $underlay: document.querySelector('.js-bisPopUpUnderlay'),
      $title: component.querySelector('.js-bisProductTitle'),
      $optionsContainer: component.querySelector('.js-bisOptionContainer'),
      $input: component.querySelector('.js-bisEmail'),
      $productId: component.querySelector('.js-bisProductId'),
      $variantId: component.querySelector('.js-bisVariantId'),
      $form: component.querySelector('.js-bisForm'),
      $responseMessage: component.querySelector('.js-responseMessage'),
      $responseMessageError: component.querySelector('.js-responseError'),
    }
    this.state = {
      open: false,
      openPopUpClass: 'openPopUp',
      activeUnderlayClass: 'isActive',
      singleOptionClass: 'singleOption',
      showSuccessClass: 'success',
      showErrorClass: 'error',
    }
    this.closePopUpHandler = this.closePopUp.bind(this)
    this.submitHandler = this.submit.bind(this)
    this.setProductInfoHandler = this.setProductInfo.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$closePopUp.forEach($toggle => $toggle.addEventListener('click', this.closePopUpHandler))
    dom.$form.addEventListener('submit', this.submitHandler)
    document.addEventListener('bistrigger', this.setProductInfoHandler)
  }

  setProductInfo({ detail }) {
    const { dom, state } = this
    dom.$title.textContent = detail.productTitle
    dom.$productId.value = detail.productId
    dom.$variantId.value = detail.variantId

    if (detail.color) {
      const colorOption = document.createElement('div')
      colorOption.className = 'BackInStockPopup__option'
      colorOption.innerHTML = `
        <span class="Swatch bisPopUp">
          <span
            class="Swatch__inset productSwatch"
            data-color="${detail.color.toLowerCase().replace(' ', '-')}"
          ></span>
        </span>
        <span class="rmp-small">
          ${detail.color}
        </span>
      `
      dom.$optionsContainer.append(colorOption)
    }

    if (detail.size) {
      const sizeOption = document.createElement('div')
      sizeOption.className = 'BackInStockPopup__option'
      sizeOption.innerHTML = `
        <span class="rmp-small">
          Size ${detail.size}
        </span>
      `
      dom.$optionsContainer.append(sizeOption)
    }

    if (!(detail.size && detail.color)) {
      dom.$optionsContainer.classList.add(state.singleOptionClass)
    }

    this.openPopUp()
  }

  openPopUp() {
    const { dom, state } = this
    dom.$component.setAttribute('aria-hidden', 'false')
    dom.$component.setAttribute('aria-expanded', 'true')
    dom.$component.classList.add(state.openPopUpClass)
    dom.$underlay.classList.add(state.activeUnderlayClass)
    state.open = true
  }

  closePopUp() {
    const { dom, state } = this
    dom.$component.setAttribute('aria-hidden', 'true')
    dom.$component.setAttribute('aria-expanded', 'false')
    dom.$component.classList.remove(state.openPopUpClass)
    dom.$underlay.classList.remove(state.activeUnderlayClass)
    dom.$title.textContent = ''
    dom.$productId.value = ''
    dom.$variantId.value = ''
    dom.$optionsContainer.innerHTML = ''
    dom.$responseMessage.innerHTML = ''
    dom.$responseMessage.classList.remove(state.showSuccessClass)
    dom.$responseMessage.classList.remove(state.showErrorClass)
    dom.$optionsContainer.classList.remove(state.singleOptionClass)
    state.open = false
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.BackInStockPopup = this
  }

  async submit(event) {
    event.preventDefault()

    const { dom, state } = this
    const variantID = parseInt(dom.$variantId.value)
    const customersEmail = dom.$input.value
    const token = 'YskzNZ'

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2025-04-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: customersEmail,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantID}`,
              },
            },
          },
        },
      }),
    }
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${token}`, options)
      if (response.status === 202) {
        dom.$responseMessage.classList.add(state.showSuccessClass)
      } else {
        dom.$responseMessageError.classList.add(state.showErrorClass)
      }
    } catch (error) {
      console.log('Error submitting BIS notification.', error)
    }
  }
}
